import React, { useState, useEffect } from "react";
import axios from "axios";

function Notification() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const studentId = localStorage.getItem("studentId"); // or from config
  const currentSessionId = localStorage.getItem("currentSessionId");

  useEffect(() => {
    const fetchNotifications = async () => {
      if (!studentId || !currentSessionId) return;

      try {
        // 1️⃣ Fetch student info (class & section)
        const studentRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents/${studentId}`,
          { params: { sessionId: currentSessionId } }
        );
        const student = studentRes.data;

        const classesRes = await axios.get(
  `${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`,
  { params: { sessionId: currentSessionId } }
);

const classes = classesRes.data;
console.log("Fetched classes:", classes);
const matchedClass = classes.find(
  cls =>
    cls.className === student.class &&
    cls.sessionId === currentSessionId
);

if (!matchedClass) {
  console.error("Class not found");
  return;
}

const matchedSection = matchedClass.sections.find(
  sec => sec.sectionName === student.section
);

if (!matchedSection) {
  console.error("Section not found");
  return;
}

const classId = matchedClass._id;      // ✅ CORRECT ID
const sectionId = matchedSection._id;  // ✅ CORRECT ID



        // 2️⃣ Fetch general notifications (sendTo: 'students' or 'both')
        const generalRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/notifications/getNotification`, {
          params: { sessionId: currentSessionId, role: "students", userId: studentId },
        });
        const generalNotifications = generalRes.data
          .filter(n => n.sendTo === "students" || n.sendTo === "both")
          .map(n => ({ ...n, deleteDate: new Date(n.deleteDate).toISOString().split("T")[0] }));

        // 3️⃣ Fetch classwise notifications
        const classRes = await axios.get(
  `${process.env.REACT_APP_API_BASE_URL}/api/notificationsClasswise/getNotificationsByClassAndSection/${classId}/${sectionId}`,
  { params: { sessionId: currentSessionId } }
);


        const classNotifications = classRes.data.map(n => ({
          ...n,
          deleteDate: new Date(n.deleteDate).toISOString().split("T")[0],
        }));
console.log("Classwise notifications:", classNotifications);
        // 4️⃣ Combine & sort
        const allNotifications = [...generalNotifications, ...classNotifications].sort(
          (a, b) => new Date(b.deleteDate) - new Date(a.deleteDate)
        );

        setNotifications(allNotifications);
      } catch (error) {
        console.error("Axios error fetching notifications:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, [studentId, currentSessionId]);

  const formatDate = (dateString) => {
    const d = new Date(dateString);
    return `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${d.getFullYear()}`;
  };

  return (
    <div className="min-h-screen flex flex-col items-center sm:p-2">
      <div className="max-w-4xl w-full bg-white rounded-lg shadow-lg p-2 sm:p-4 sm:mt-8">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800 mb-3 sm:mb-4 md:mb-6 text-center">
          Student Notifications
        </h2>

        {loading ? (
          <div className="flex justify-center">
            <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-6 w-6 sm:h-10 sm:w-10 mb-2"></div>
          </div>
        ) : notifications.length === 0 ? (
          <p className="text-center text-gray-500 text-sm sm:text-base">
            No notifications available at the moment.
          </p>
        ) : (
          <ul className="space-y-3 sm:space-y-4">
            {notifications.map((n, idx) => (
              <li
                key={idx}
                className={`bg-white border ${new Date(n.deleteDate) < new Date() ? "border-red-300" : "border-gray-200"} 
                  rounded-lg p-2 sm:p-3 shadow-md transform hover:shadow-lg transition-shadow duration-300`}
              >
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between">
                  <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-900">{n.title}</h3>
                  <p
                    className={`text-xs sm:text-sm md:text-base ${
                      new Date(n.deleteDate) < new Date() ? "text-red-500" : "text-gray-500"
                    } mt-1 md:mt-0`}
                  >
                    {formatDate(n.deleteDate)}
                  </p>
                </div>
                <p className="text-gray-700 mt-2 sm:mt-3 text-xs sm:text-sm">{n.content}</p>
                {n.attachFile && (
                  <a
                    href={n.attachFile}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 mt-2 inline-flex items-center text-xs sm:text-sm hover:underline"
                  >
                    View Attachment
                  </a>
                )}
                {new Date(n.deleteDate) < new Date() && (
                  <div className="mt-2 text-red-500 flex items-center text-xs sm:text-sm">
                    This notification has expired.
                  </div>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Notification;
